<template>
  <div class="log-oppea-box">
    <div class="item">操作用户：{{rowItem.operatedUserPO && rowItem.operatedUserPO.realName}}</div>
    <div class="item">被操作对象：{{form && form.updateTag}}</div>
    <div class="item">修改时间：{{rowItem.operatedTime}}</div>
    <el-row v-if="form">
      <el-col :span="12" v-if="form.beforeStr">
        <div class="grid-content">
          <div class="title">变更前</div>
          <template v-if="form.beforeStr.autoReplyMap">
            <div class="item">关键词：{{form.beforeStr.autoReplyMap.keyword}}</div>
            <div class="item">回复话术：{{form.beforeStr.autoReplyMap.content}}</div>
          </template>
        </div>
      </el-col>
      <el-col :span="12" v-if="form.afterStr ">
        <div class="grid-content log-line">
          <div class="title">变更后</div>
          <template v-if="form.afterStr.autoReplyMap">
            <div class="item">关键词：{{form.afterStr.autoReplyMap.keyword}}</div>
            <div class="item">回复话术：{{form.afterStr.autoReplyMap.content}}</div>
          </template>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import sysDataCompareLogApi from '@/api/log/sysDataCompareLog'
export default {
  props: ['rowItem'],
  data() {
    return {
      form: null
    }
  },
  created() {
    this.getLogShow()
  },
  methods: {
    getLogShow() {
      sysDataCompareLogApi.fetchById(this.rowItem.id).then(res => {
        this.form = res.data;

      })
    }
  }

}
</script>

<style lang="scss" scoped>
.title-box {
  margin: 10px 24px 15px 0;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 5px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}
</style>
